import script from "./DashboardAssist.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardAssist.vue?vue&type=script&setup=true&lang=js"

import "./DashboardAssist.vue?vue&type=style&index=0&id=559ca97f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-559ca97f"]])

export default __exports__